import styled from 'styled-components';

export const PitcherViewWrapper = styled.div`
  padding-bottom: 15px;
`;
